import React, { useMemo } from 'react';

import parsePhoneNumber from 'libphonenumber-js';
import cx from 'clsx';

import './style.scss';

export const ResultItem = ({
    member: {
        firstName,
        lastName,
        postalAddress,
        phone: _phone,
        email,
        uuid
    },
    embeddedInPopover = false
}) => {

    const phone = ((_phone && _phone.trim().length)
        ? parsePhoneNumber(_phone, 'US')
        : null
    );

    const postalAddressLines = useMemo(() => postalAddress
        .split('\n')
        .filter(line => !line || line.trim().length)
        .map(((line, i) => (
            <p key={i}>{line}</p>
        ))
    ), postalAddress);


    const hasContact = phone || email;

    const Tag = embeddedInPopover ? 'div' : 'li';

    return (
        <Tag
            className={cx(
                'cbdce-education-finder__result-item',
                embeddedInPopover && 'cbdce-education-finder__result-item--embedded',
            )}
        >

            <h6 className="cbdce-heading cbdce-heading--md">
                <a
                    href={`/profile/view/${uuid}`}
                    className="cbdce-education-finder__result-item-name cbdce-button cbdce-text-button"
                    target="_blank"
                >
                    {firstName} {lastName}
                </a>
            </h6>
            {postalAddressLines && (
                <address className="cbdce-education-finder__result-item-address">
                    { postalAddressLines }
                </address>
            )}
            {hasContact && (
                <dl className="cbdce-education-finder__result-item-contact">
                    {phone && (
                        <>
                            <dd>Phone:</dd>
                            <dt>
                                <a
                                    href={phone.getURI()}
                                    className="cbdce-button cbdce-text-button"
                                    target="_blank"
                                >
                                    {phone.formatNational()}
                                </a>
                            </dt>
                        </>
                    )}
                    {email && (
                        <>
                            <dd>Email:</dd>
                            <dt>
                                <a
                                    href={`mailto:${email}`}
                                    className="cbdce-button cbdce-text-button"
                                    target="_blank"
                                    rel="noopener norefferer"
                                >
                                    {email}
                                </a>
                            </dt>
                        </>
                    )}
                </dl>
            )}
        </Tag>
    );
}

export default ResultItem;
